const INPUT_TYPE_LABELS: Record<string, string> = {
    Manually:             'Manually',
    Scanned:              'Scanned',
    ManuallyAfterClosing: 'Manually After Closing',
    Linked:               'Linked',
    LinkRemoved:          'Link Removed',
};

export const formatInputType = (inputType?: string | null): string =>
    inputType ? (INPUT_TYPE_LABELS[inputType] ?? inputType) : 'N/A';

export const convertStrDateUTCToStrDateGB = (dateStr: string): string => {
    return new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    }).format(new Date(dateStr));
};